type EnvironmentType = 'development' | 'production' | 'staging';

const isProduction =
  process.env.BUILD_ENV === 'production' ||
  process.env.NEXT_PUBLIC_BUILD_ENV === 'production';

const isDevelopment =
  process.env.BUILD_ENV === 'development' ||
  process.env.NEXT_PUBLIC_BUILD_ENV === 'development';

const ENVIRONMENT: EnvironmentType = isDevelopment
  ? 'development'
  : isProduction
  ? 'production'
  : 'staging';

const websocketEndpoints: Record<
  EnvironmentType,
  {
    websocket: string;
    websocketAnonymous: string;
  }
> = {
  development: {
    websocket: 'wss://wsmux.go-e-cloud.de/v1',
    websocketAnonymous: 'wss://wsmux.goelabs.de/v1',
  },
  production: {
    websocket: 'wss://wsmux.go-e-cloud.de/v2',
    websocketAnonymous: 'wss://wsmux.go-e-cloud.de/v1',
  },
  staging: {
    websocket: 'wss://wsmux.goelabs.de/v2',
    websocketAnonymous: 'wss://wsmux.goelabs.de/v1',
  },
};

const { websocket, websocketAnonymous } = websocketEndpoints[ENVIRONMENT];

const backendUrls = {
  export: {
    getSessionData: (exportToken: string): string =>
      `https://data.v3.go-e.io/api/v1/direct_json?source=app&e=${exportToken}`,
  },
  // old API not in use anymore but will keep it here as backup for now: wss://app.v3.go-e.io/multi_api
  multiApi: {
    websocket: websocket,
    websocketRequiresToken: !isDevelopment,
    websocketAnonymous: websocketAnonymous,
  },
  tariffs: {
    list: 'https://data.v3.go-e.io/list',
  },
  changelog: 'https://data.v3.go-e.io/firmware_changelog',
  shareFeedback: 'https://go-e.survalyzer.eu/fsxzuariue',
  statusPage: 'https://status.go-e.com/status/go-e',
  operatorPLMN: 'https://mcc-mnc.org/',
};

export default backendUrls;
